import { Component, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { User } from 'src/app/core/users/users.model';
import { ApiService } from 'src/app/services/api.service';
import { MatDialog } from '@angular/material/dialog';
import { tap, catchError, first } from 'rxjs/operators';
import { SuccessRequestComponent } from 'src/app/shared/success-request/success-request.component';
import { FailRequestComponent } from 'src/app/shared/fail-request/fail-request.component';
import { Router } from '@angular/router';
import { throwError, Observable } from 'rxjs';
import { select } from '@angular-redux/store';
import { GeoPos } from 'src/app/core/geographicalpos/geographicalpos.model';
import { UserActionService } from 'src/app/core/users/users.action';

@Component({
  selector: 'app-new-user',
  templateUrl: './new-user.component.html',
  styleUrls: ['./new-user.component.scss']
})
export class NewUserComponent implements OnInit {
  @ViewChild('authSelection') auth_selection: any;
  @ViewChild('geoposSelection') geopos_selection: any;

  @select(['logged', 'logged'])
  user_logged$: Observable<any>;
  user_logged: User;
  @select(['geopos', 'list'])
  geopos_list$: Observable<any>;
  geopos_list: GeoPos[] = [];

  user_current: User = {
    id: null,
    name: '',
    auth_user: '',
    geopos: [],
    isadmin: false,
    password: ''
  };

  current_lang = 'it';
  admin_auth = ['admin', 'editor', 'blocked'];
  superadmin_auth = ['superadmin', 'admin', 'editor', 'blocked'];
  auth: string[];

  loading = false;

  constructor(private titleService: Title,
              private translate: TranslateService,
              private apiservice: ApiService,
              private userAction: UserActionService,
              private route: Router,
              public dialog: MatDialog) {
      this.translate.setDefaultLang('it');
      if (this.translate.currentLang) {
        this.translate.use(this.translate.currentLang);
      } else {
        this.translate.use('it');
      }
      this.translate.get('breadcrumb.new_user').subscribe((res: string) => {
        this.titleService.setTitle(res + ' - PRIMIS');
      });
      this.translate.onLangChange.subscribe(() => {
        this.translate.get('breadcrumb.new_user').subscribe((res: string) => {
          this.titleService.setTitle(res + ' - PRIMIS');
        });
      });
    }

  ngOnInit(): void {
    this.user_logged$.pipe(
      first(),
      tap((user) => {
        this.user_logged = user;
        if (this.user_logged.auth_user === 'superadmin') {
          this.auth = this.superadmin_auth;
        } else if (this.user_logged.auth_user === 'admin') {
          this.auth = this.admin_auth;
          this.user_current.geopos = this.user_logged.geopos;
        }
      })
    ).subscribe();
    this.geopos_list$.pipe(
      first(),
      tap((list) => {
        this.geopos_list = [...list];
      })
    ).subscribe();
  }

  checkGeopos(geopos) {
    if (this.user_current.geopos.length > 0) {
      return geopos.id === this.user_current.geopos[0].id;
    } else {
      return false;
    }
  }

  routerFunction(path_to_new_page) {
    this.route.navigate([path_to_new_page]);
  }

  authSelectionFunction() {
    const isSuperAdmin = this.user_current.auth_user === 'superadmin';
    this.user_current.isadmin = isSuperAdmin;
    if (isSuperAdmin) {
      this.user_current.geopos = [...this.geopos_list];
    } else if (this.user_logged.auth_user === 'superadmin') {
      this.user_current.geopos = [];
    } else {
      this.user_current.geopos = [...this.user_logged.geopos];
    }
  }

  geoposSelectionFunction() {
    this.user_current.geopos = this.geopos_selection.selectedOptions.selected.map((opt) => opt._value);
  }

  saveUser() {
    this.loading = true;
    this.apiservice.newUser(this.user_current).pipe(
      tap((x: any) => {
        if (x && !x.error) {
          this.userAction.addOrUpdateUser(x);
          this.loading = false;
          const dialogRef = this.dialog.open(SuccessRequestComponent, {
            width: '450px'
          });
          dialogRef.afterClosed().subscribe(() => this.routerFunction('/lista-utenti'));
        }
      }),
      catchError(error => {
        this.loading = false;
        this.dialog.open(FailRequestComponent, {
          width: '450px'
        });
        return throwError(error);
      })
    ).subscribe();
  }

  saveButtonDisabled() {
    const isValid =
      !!this.user_current.name && !!this.user_current.auth_user &&
      this.user_current.geopos.length > 0 && !!this.user_current.password;
    return !isValid;
  }

}
